import { getApiOrigin } from "../../../utils/apiBase";

export const DOCTORS_BASE = "/manage/app/trainers";

const API_ORIGIN = getApiOrigin();

export function doctorPhotoUrl(photoUrl) {
  if (!photoUrl) return null;
  if (photoUrl.startsWith("http")) return photoUrl;
  return `${API_ORIGIN}${photoUrl}`;
}

export const DOCTOR_TABS = [
  { id: "overview", label: "Обзор" },
  { id: "calendar", label: "Календарь" },
  { id: "schedule", label: "Расписание" },
  { id: "services", label: "Услуги" },
  { id: "profile", label: "Профиль" },
  { id: "limits", label: "Правила записи" },
  { id: "waitlist", label: "Очередь" },
  { id: "audit", label: "История" },
];

/** Вкладки профиля тренера в PWA */
export const TRAINER_PWA_TABS = [
  { id: "overview", label: "Обзор" },
  { id: "calendar", label: "Календарь" },
  { id: "schedule", label: "Расписание" },
  { id: "assignments", label: "Назначения" },
  { id: "waitlist", label: "Очередь" },
  { id: "settings", label: "Профиль" },
];

const TRAINER_PWA_TAB_IDS = new Set(TRAINER_PWA_TABS.map((t) => t.id));

export function resolveTrainerPwaTab(tabFromUrl) {
  return TRAINER_PWA_TAB_IDS.has(tabFromUrl) ? tabFromUrl : "overview";
}

export const SLOT_TYPE_LABELS = {
  in_person: "Очный",
  telemedicine: "ТМК",
  screening: "Диспансеризация",
  paid: "Платный",
};

export const EMPTY_EDIT = {
  full_name: "",
  specialization: "",
  specialization_id: "",
  description: "",
  email: "",
  is_active: true,
  branchIds: [],
  directionIds: [],
  groupIds: [],
  experience_years: "",
  max_appointments_per_day: "",
  min_break_minutes: "",
  substitute_doctor_id: "",
  notify_appointments: true,
  mis_external_id: "",
};

export function doctorBranchOptionsFromResponse(doctor) {
  return doctor?.branch_options || doctor?.branches || [];
}

export function pickDefaultBranchId(branches = []) {
  const list = filterAssignedBranches(branches);
  const def = list.find((b) => b.is_default) || list[0];
  return def?.id || "";
}

export function filterAssignedBranches(branches = []) {
  if (!branches.length) return [];
  if (branches.some((b) => "assigned" in b)) {
    return branches.filter((b) => b.assigned);
  }
  return branches;
}

export function assignedBranchIds(branches = []) {
  return filterAssignedBranches(branches).map((b) => b.id);
}

export function doctorToEdit(doctor, branches = []) {
  return {
    full_name: doctor?.full_name || "",
    specialization: doctor?.specialization || "",
    specialization_id: doctor?.specialization_id || "",
    description: doctor?.description || "",
    email: doctor?.email || "",
    is_active: doctor?.is_active !== false,
    branchIds: assignedBranchIds(branches),
    directionIds: (doctor?.direction_ids || doctor?.directions || []).map((d) =>
      typeof d === "string" ? d : d.id,
    ),
    groupIds: (doctor?.group_ids || doctor?.groups || []).map((g) =>
      typeof g === "string" ? g : g.id,
    ),
    experience_years:
      doctor?.experience_years != null ? String(doctor.experience_years) : "",
    max_appointments_per_day:
      doctor?.max_appointments_per_day != null
        ? String(doctor.max_appointments_per_day)
        : "",
    min_break_minutes:
      doctor?.min_break_minutes != null
        ? String(doctor.min_break_minutes)
        : "",
    substitute_doctor_id: doctor?.substitute_doctor_id || "",
    notify_appointments: doctor?.notify_appointments !== false,
    mis_external_id: doctor?.mis_external_id || "",
  };
}
